import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "antd/dist/reset.css"; // AntD v5 reset styles
import { AuthProvider } from "context/AuthContext";
// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import "./index.css";
import "./assets/css/antd-overrides.css";
const container = document.getElementById("app");
const root = createRoot(container);


root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
